import { ActionNode } from '../Action/TypedNode'
import { PageModel } from '../Page/ViewModel'
import { ActionCallPageDefinition } from './TypedDefinition'

import type { ActionSpecific } from '../Action/TypedNode'
import type { AnyExpressionSpecific } from '../Mustache'
import type { TypedSpecific, ViewScope } from '@rehaje/core'
import type { RecursionType, TRecord } from '@rehaje/shared'

export interface ActionCallPageSpecific extends ActionSpecific {
  props: {
    openWay?: 'currentTab' | 'newTab' | AnyExpressionSpecific
    params?: RecursionType<TypedSpecific>
    url?: AnyExpressionSpecific | string
  }
  type: `Action.CallPage`
}

export interface CallPageProps {
  openWay?: 'currentTab' | 'newTab'
  params?: TRecord
  url?: string
}

export class ActionCallPageNode extends ActionNode {
  static definition = ActionCallPageDefinition

  override async handler(props: CallPageProps, scope: ViewScope) {
    if (props.url) {
      const page = scope.variables.page
      if (page instanceof PageModel) {
        page.navigate(props.url, props.params, props.openWay)
      }
    }
  }
}

declare global {
  export interface RehajeSpecifics {
    'Action.CallPage': ActionCallPageSpecific
  }
  export interface RehajeTypedNodes {
    'Action.CallPage': ActionCallPageNode
  }
}
